import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Subscription } from 'rxjs';

interface NavItem {
  label: string;
  path: string;
  auth: boolean;
  emoji: string;
}

const NAV_ITEMS: NavItem[] = [
  { label: 'Blacksmithing',   path: '/blacksmithing',   auth: true,  emoji: '⚒️' },
  { label: 'Machining',       path: '/machining',       auth: true,  emoji: '🛠️' },
  { label: 'Illustrator',     path: '/adobe-illustrator', auth: true, emoji: '✒️' },
  { label: 'Guitar App',      path: '/guitar-app',      auth: false, emoji: '🎸' },
  // { label: 'Denver Itinerary',       path: '/itinerary',       auth: false, emoji: '🗺️' },
  // { label: 'Ren Faire',       path: '/ren-faire',       auth: false, emoji: '⚔️' },
  { label: 'Money Manager',   path: '/money-manager',   auth: true,  emoji: '💰' },
  { label: 'Workout Tracker', path: '/workout-tracker', auth: true,  emoji: '🏋️' },
  { label: 'Habit Tracker',   path: '/challenge',       auth: true,  emoji: '🎯' },
  { label: 'VAWT Tracker',   path: '/vawt-tracker',   auth: true,  emoji: '⚡' },
  { label: 'Recipe Book',     path: '/recipe',          auth: true,  emoji: '📖' },
  { label: 'Stitch Maker',    path: '/stitch-maker',    auth: false, emoji: '🧵' },
  { label: 'Draft',           path: '/draft',           auth: false, emoji: '📋' },
  // { label: 'Coup',            path: '/coup',            auth: false, emoji: '🃏' },
  { label: 'Plants',          path: '/plants',          auth: false, emoji: '🌱' },
  // { label: 'Pixelize',        path: '/pixelize',        auth: false, emoji: '🖼️' },
  { label: 'Custom Grid',     path: '/custom-grid',     auth: false, emoji: '⬛' },
  { label: 'PCB Stator',      path: '/pcb-stator',      auth: false, emoji: '⚙️' },
  { label: 'Nacho Gallery',   path: '/nacho-gallery',   auth: false, emoji: '🐕' },
  { label: 'New Internet',    path: '/new-internet',    auth: true,  emoji: '🌐' },
  // { label: 'Swole City',      path: '/swolecity',       auth: false, emoji: '💪' },
];

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  menuOpen = false;
  isLoggedIn = false;
  isScrolled = false;

  get visibleItems(): NavItem[] {
    return NAV_ITEMS.filter(item => !item.auth || this.isLoggedIn);
  }

  private authSub?: Subscription;

  constructor(private afAuth: AngularFireAuth, public router: Router) {}

  ngOnInit() {
    this.authSub = this.afAuth.authState.subscribe(user => {
      this.isLoggedIn = !!user;
    });
  }

  ngOnDestroy() {
    this.authSub?.unsubscribe();
  }

  @HostListener('window:scroll')
  onScroll() {
    this.isScrolled = (window.scrollY || document.documentElement.scrollTop) > 10;
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.menuOpen = false;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  navigate(path: string) {
    this.router.navigate([path]);
    this.menuOpen = false;
  }
}
